import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { firestore } from '../../../config/Fire'
import * as Constants from '../../../constants'
import { Button, Divider, message, DatePicker } from 'antd'
import moment from "moment";
import { getUser } from '../../../reducers'
import './listWorksStyles.css'
import WorkOrdersTable from '../../containers/WorkOrdersTable'
import { useHistory } from 'react-router-dom'
import { storage } from '../../../config/Fire'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { DownloadOutlined } from '@ant-design/icons'


const { RangePicker } = DatePicker;

function compareByWorkOrderYear(a, b) {
    if (a.year > b.year) {
        return -1
    } else {
        if (a.year === b.year) {
            if (a.workOrderNumber > b.workOrderNumber) {
                return -1
            } else {
                return 1
            }
        } else {
            return 1
        }
    }
}


const ALLOWED_EXPORT_EMAILS = [
	'ingenierosaravia@sdingenieria.com.ar',
	'gabrielsaravia@sdingenieria.com.ar',
	'melinabodini@sdingenieria.com.ar',
	'pruebas@autosolve.com'
]

const ListWorks = props => {
	const { works, employees, clients, bids, companyType = 'Arcasa', user } = props
    const [loadingWorkOrders, setLoadingWorkOrders] = useState(false)
    const [percentSI, setPercentSI] = useState(0);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const history = useHistory();

    useEffect(() => {
        if (!startDate || !endDate) {
            const today = new Date();
            if (works && works.length > 0) {
                const dates = works.map(work => new Date(work.expectedCompletionDate));
                const minDate = new Date(Math.min(...dates));
                setStartDate(`${minDate.getDate()}/${minDate.getMonth() + 1}/${minDate.getFullYear()}`);
                setEndDate(`${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`);
            } else {
                const oneYearAgo = new Date(today);
                oneYearAgo.setFullYear(today.getFullYear() - 1);
                setStartDate(`${oneYearAgo.getDate()}/${oneYearAgo.getMonth() + 1}/${oneYearAgo.getFullYear()}`);
                setEndDate(`${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`);
            }
        }
        didCalculatePercentaje();
    }, [works]);

    const showWorkOrder = id => {
        history.push(`/editar_trabajo/${id}`)
    }

    const removeWorkOrder = id => {
        if (id) {
            setLoadingWorkOrders(true)
            // Ya no actualizamos workOrderId en el bid - ahora la relación es solo por bidId en works
            firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(id).delete()
                .then(() => {
                    // Borrar el archivo OT.pdf del storage (la cotización aprobada ya no se guarda en storage)
                    return storage.ref().child(`works/${id}/OT.pdf`).delete().catch(err => {
                        // Si el archivo no existe, no es un error crítico
                        console.log('Error al borrar OT.pdf (puede que no exista):', err)
                    })
                })
                .then(() => {
                    setLoadingWorkOrders(false)
                    message.success('La orden de trabajo se borro exitósamente')
                    props.onWorkOrderDeleted(id)
                })
                .catch(err => {
                    setLoadingWorkOrders(false)
                    console.log(err)
                    message.error('Se produjo un error al eliminar la orden de trabajo. Por favor, vuelva a intentarlo')
                })
        }
    }

    const filterTableByDate = (dates, strings) => {
        var start = strings[0];
        var end = strings[1];
        setStartDate(start)
        setEndDate(end)
        setPercentSI(0);
    }

    const didCalculatePercentaje = () => {
        var count = 0;
        var total = 0;

        const parseDate = (dateString) => {
            const parts = dateString.split('/');
            if (parts.length === 3) {
                return new Date(parts[2], parts[1] - 1, parts[0]);
            }
            return new Date(NaN);
        };

        works && Object.values(works).forEach(workOrder => {
            if (workOrder.expectedCompletionDate !== '') {
                const expectedDate = parseDate(workOrder.expectedCompletionDate);
                const startDate1 = parseDate(startDate);
                const endDate1 = parseDate(endDate);
                if (!isNaN(expectedDate)) {
                    if (expectedDate >= startDate1 && expectedDate <= endDate1) {
                        total++;
                        if (isWorkOrderOnTime(workOrder) === 'SI') {
                            count++;
                        }
                    }
                } else {
                    console.error(`Invalid date: ${workOrder.expectedCompletionDate}`);
                }
            }
        });

        if (total !== 0) {
            setPercentSI(Math.round((count / total) * 100));
        }
    };

    const isWorkOrderOnTime = workOrder => {
        if (workOrder.expectedCompletionDate !== '' && workOrder.effectiveEndDate !== '') {
            const expectedDateLong = moment(`${workOrder.expectedCompletionDate} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').toDate().getTime()
            const endDateLong = moment(`${workOrder.effectiveEndDate} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').toDate().getTime()
            if (expectedDateLong >= endDateLong) {
                return 'SI'
            } else {
                return 'NO'
            }
        } else {
            if (workOrder.expectedCompletionDate !== '') {
                const todayDateLong = moment(`${moment().utcOffset('-0300').format('DD/MM/YYYY')} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').toDate().getTime()
                const expectedDateLong = moment(`${workOrder.expectedCompletionDate} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').toDate().getTime()
                if (todayDateLong <= expectedDateLong) {
                    return '-'
                } else {
                    return 'NO'
                }
            } else {
                return '-'
            }
        }
    }

    const getOTLabel = record => {
        if (!record) return '--'
        const company = record.company === 'SD' ? 'SYD' : record.company === 'Arcasa' ? 'ARC' : 'O/T'
        const yearStr = record.year ? record.year.toString().substring(2, 4) : ''
        if (record.SAT) {
            return `${company} Nº${record.workOrderNumber || ''}/${yearStr} (SAT)`
        } else {
            return `${company} Nº${record.workOrderNumber || ''}/${yearStr}`
        }
    }

    const getQuotation = workId => {
        let label = ''
        if (bids && workId) {
            Object.values(bids).forEach(bid => {
                if (bid.workOrderId === workId) {
                    label = bid.quotation
                }
            })
            if (!label && works && works[workId]) {
                const work = works[workId]
                if (work && work.bidId && bids[work.bidId]) {
                    label = bids[work.bidId].quotation
                }
            }
        }
        return label || '--'
    }

    const getFullAreaNames = areas => {
        if (!areas || !Array.isArray(areas) || areas.length === 0) return '--'
        const mapped = areas.map(area => {
            if (Constants.areaWorkOrderMap && Constants.areaWorkOrderMap[area]) {
                return Constants.areaWorkOrderMap[area]
            }
            return area
        })
        return mapped.join(';')
    }

    const getClientNames = clientIds => {
        if (!clientIds || !Array.isArray(clientIds) || clientIds.length === 0) return '--'
        const names = clientIds
            .map(id => (clients && clients[id] ? clients[id].name : null))
            .filter(Boolean)
        return names.length > 0 ? names.join('; ') : '--'
    }

    const getTotalBilling = record => {
		if (record && record.invoicedFreePercentaje !== undefined && record.invoicedPercentaje !== undefined) {
			return `${record.invoicedFreePercentaje - record.invoicedPercentaje}%`
		}
		return '0%'
	}

	const getAmountToInvoice = record => {
		if (!record || !Array.isArray(record.selectedItems) || record.selectedItems.length === 0) return '0 USD'
		const total = record.selectedItems.reduce((sum, item) => {
			const price = parseFloat(item && item.priceUsd)
			return sum + (isNaN(price) ? 0 : price)
		}, 0)
		return `${total} USD`
	}

	const exportWorksToExcel = async () => {
		try {
			message.loading({ content: 'Generando Excel de Órdenes de Trabajo...', key: 'excel_works' })
			const workList = (works && Object.keys(works).length !== 0)
				? Object.values(works).sort(compareByWorkOrderYear)
				: []

			if (workList.length === 0) {
				message.warning({ content: 'No hay órdenes de trabajo para exportar', key: 'excel_works' })
				return
			}

			const workbook = new ExcelJS.Workbook()
			const worksheet = workbook.addWorksheet('Órdenes de Trabajo')

			const titleRow = worksheet.addRow([`ÓRDENES DE TRABAJO - ${companyType.toUpperCase()}`])
			worksheet.mergeCells('A1:I1')
			const titleCell = titleRow.getCell(1)
			titleCell.font = { name: 'Calibri', size: 14, bold: true, color: { argb: 'FFFFFFFF' } }
			titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1B365D' } }
			titleCell.alignment = { horizontal: 'center', vertical: 'middle' }
			titleRow.height = 30

			const dateStr = moment().format('DD/MM/YYYY HH:mm')
			const subTitleRow = worksheet.addRow([`Fecha de generación: ${dateStr}`])
			worksheet.mergeCells('A2:I2')
			const subTitleCell = subTitleRow.getCell(1)
			subTitleCell.font = { name: 'Calibri', size: 10, italic: true, color: { argb: 'FF555555' } }
			subTitleCell.alignment = { horizontal: 'right', vertical: 'middle' }
			subTitleRow.height = 18

			worksheet.addRow([])

			const headers = [
				'Orden de trabajo',
				'Cotizacion',
				'Areas',
				'Localidad',
				'Comitente',
				'Tarea',
				'Fecha de entrega',
				'Monto a facturar',
				'Pendiente de facturar'
			]
			const headerRow = worksheet.addRow(headers)
			headerRow.height = 25

			const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF263238' } }
			const headerFont = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFFFFFF' } }
			const borderStyle = {
				top: { style: 'thin', color: { argb: 'FFD3D3D3' } },
				left: { style: 'thin', color: { argb: 'FFD3D3D3' } },
				bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } },
				right: { style: 'thin', color: { argb: 'FFD3D3D3' } }
			}

			headerRow.eachCell(cell => {
				cell.fill = headerFill
				cell.font = headerFont
				cell.alignment = { horizontal: 'center', vertical: 'middle' }
				cell.border = borderStyle
			})

			workList.forEach((work, index) => {
				const rowData = [
					getOTLabel(work),
					getQuotation(work.id),
					getFullAreaNames(work.areas),
					work.locality || '--',
					getClientNames(work.clientIds),
					work.task || '--',
					work.expectedCompletionDate || '--',
					getAmountToInvoice(work),
					getTotalBilling(work)
				]

				const row = worksheet.addRow(rowData)
				row.height = 22

				const isEven = index % 2 === 0
				const rowFill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: isEven ? 'FFFFFFFF' : 'FFF4F6F8' }
				}

				row.eachCell((cell, colNumber) => {
					cell.fill = rowFill
					cell.border = borderStyle
					cell.font = { name: 'Calibri', size: 10 }

					if ([1, 2, 7, 8, 9].includes(colNumber)) {
						cell.alignment = { horizontal: 'center', vertical: 'middle' }
					} else {
						cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true }
					}
				})
			})

			worksheet.getColumn(1).width = 22
			worksheet.getColumn(2).width = 20
			worksheet.getColumn(3).width = 32
			worksheet.getColumn(4).width = 25
			worksheet.getColumn(5).width = 30
			worksheet.getColumn(6).width = 45
			worksheet.getColumn(7).width = 18
			worksheet.getColumn(8).width = 20
			worksheet.getColumn(9).width = 22

			const buffer = await workbook.xlsx.writeBuffer()
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileDate = moment().format('DD-MM-YYYY')
			saveAs(blob, `Ordenes_de_Trabajo_${companyType}_${fileDate}.xlsx`)
			message.success({ content: 'Excel descargado exitosamente', key: 'excel_works' })
		} catch (err) {
			console.error('Error exporting works to Excel:', err)
			message.error({ content: 'Error al generar el archivo Excel', key: 'excel_works' })
		}
	}

    return (
        <Grid className="listWorksCont">
            <Row center="xs">
                <Col xs={12}>
                    <h2>Ordenes de trabajo {companyType}</h2>
                </Col>
            </Row>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ border: '1px solid black', padding: '4px', marginBottom: "2%", width: '50%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Row center="xs" style={{ width: '100%' }}>
                        <RangePicker className="rangePickerCont" format={'DD/MM/YYYY'} defaultValue={[startDate, endDate]} onChange={filterTableByDate} />
                        <Button className="calcular" onClick={() => { didCalculatePercentaje() }} type="dashed" size="default">Calcular "a tiempo"</Button>
                    </Row>
                    <h3 style={{ marginTop: '10px' }}>A tiempo: SI: {percentSI || '-'} %</h3>
                </div>
            </div>
            <div style={{ position: 'relative', marginBottom: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Row center="xs">
                    <div className='circleOrangeL'></div>
                    <h3>EN PROCESO</h3>
                    <div className='circleGreenL'></div>
                    <h3>FINALIZADO</h3>
                    <div className='circleGrayL'></div>
                    <h3>ANULADO</h3>
                </Row>
                {user && user.email && ALLOWED_EXPORT_EMAILS.includes(user.email) && (
                    <div style={{ position: 'absolute', right: '0px' }}>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={exportWorksToExcel}
                            style={{ backgroundColor: '#2e7d32', borderColor: '#2e7d32' }}
                        >
                            Descargar excel
                        </Button>
                    </div>
                )}
            </div>
            <Row center="xs">
                <Col xs={12}>
                    <WorkOrdersTable
                        data={(works && works.length !== 0) ? Object.values(works).sort(compareByWorkOrderYear) : []}
                        clients={clients}
                        bids={bids}
                        employees={employees} onShowWorkOrder={showWorkOrder}
                        onRemoveWorkOrder={removeWorkOrder} loading={loadingWorkOrders} />
                </Col>
            </Row>
        </Grid>
    )
}

ListWorks.propTypes = {
}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ListWorks))
